/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RankingEntry = {
    properties: {
        fantaTeam: {
            type: 'FantaTeamSmall',
            isRequired: true,
        },
        points: {
            type: 'number',
            isRequired: true,
        },
        isAverage: {
            type: 'boolean',
            isRequired: true,
        },
        rank: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
